(() => {
  const initialize = () => {
    document.querySelectorAll('[data-snail-scroll-video]').forEach((video) => {
      if (video.dataset.snailInitialized) return;
      video.dataset.snailInitialized = 'true';
      if (!('IntersectionObserver' in window)) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let inView = false;
      let manuallyPaused = false;
      let automaticPause = false;
      const pause = () => {
        if (!video.paused) {
          automaticPause = true;
          video.pause();
        }
      };
      const update = () => {
        if (!inView || document.hidden || reducedMotion.matches) {
          pause();
        } else if (!manuallyPaused && !video.ended) {
          video.play().catch(() => {});
        }
      };
      video.addEventListener('pause', () => {
        if (!automaticPause && inView && !document.hidden && !video.ended) manuallyPaused = true;
        automaticPause = false;
      });
      video.addEventListener('play', () => { manuallyPaused = false; });
      const observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        update();
      }, { threshold: [0, 0.5] });
      observer.observe(video);
      document.addEventListener('visibilitychange', update);
      reducedMotion.addEventListener('change', update);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
